/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShipExclusionUpdateBase } from './ShipExclusionUpdateBase';
import {
    ShipExclusionUpdateBaseFromJSON,
    ShipExclusionUpdateBaseFromJSONTyped,
    ShipExclusionUpdateBaseToJSON,
    ShipExclusionUpdateBaseToJSONTyped,
} from './ShipExclusionUpdateBase';

/**
 * 
 * @export
 * @interface ShipExclusionUpdate
 */
export interface ShipExclusionUpdate {
    /**
     * 
     * @type {Array<ShipExclusionUpdateBase>}
     * @memberof ShipExclusionUpdate
     */
    body: Array<ShipExclusionUpdateBase>;
}

/**
 * Check if a given object implements the ShipExclusionUpdate interface.
 */
export function instanceOfShipExclusionUpdate(value: object): value is ShipExclusionUpdate {
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function ShipExclusionUpdateFromJSON(json: any): ShipExclusionUpdate {
    return ShipExclusionUpdateFromJSONTyped(json, false);
}

export function ShipExclusionUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipExclusionUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'body': ((json['body'] as Array<any>).map(ShipExclusionUpdateBaseFromJSON)),
    };
}

export function ShipExclusionUpdateToJSON(json: any): ShipExclusionUpdate {
    return ShipExclusionUpdateToJSONTyped(json, false);
}

export function ShipExclusionUpdateToJSONTyped(value?: ShipExclusionUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'body': ((value['body'] as Array<any>).map(ShipExclusionUpdateBaseToJSON)),
    };
}

